export const tr = {
    'phrases-caption': 'Sözcük grubu sayısı: {count}',
    'phrases-placeholder': "Satır başına 1'er sözcük grubu belirtin."
};
